// extracted by mini-css-extract-plugin
module.exports = {"mainbtn":"Buttons_mainbtn__1MZdJ","white":"Buttons_white__1KP79","nospace":"Buttons_nospace__2Q7YZ"};